import { createFileRoute } from "@tanstack/react-router";
import { AgendaPanel } from "@/components/admin/AgendaPanel";

export const Route = createFileRoute("/admin/agenda")({
  component: AgendaPanel,
});
